import { useState } from 'react';
import { RoleIcon } from '../components/Icon';
import type { GameSession } from '../game/useGameSession';
import { characterAbilityKey, characterName, roleColor } from '../game/cardMeta';
import { roleArt } from '../game/art';
import { cardBackCss, savedCardBack } from '../game/shop';
import { useT } from '../i18n';

export function RoleReveal({ session }: { session: GameSession }) {
  const t = useT();
  const { myRole, me } = session;
  const [revealed, setRevealed] = useState(false);

  if (!myRole) {
    return (
      <div className="screen center">
        <div className="mono-dim">{t.reveal.decrypting}</div>
      </div>
    );
  }

  const color = roleColor[myRole];
  const character = me?.characterId ? characterName[me.characterId] : undefined;
  const abilityKey = me?.characterId ? characterAbilityKey[me.characterId] : undefined;
  const ability = abilityKey ? t.ability[abilityKey] : undefined;

  return (
    <div className="screen center reveal-screen" style={{ ['--role-color' as string]: color }}>
      <div className="subtitle reveal-transmission">{t.reveal.title}</div>

      {!revealed ? (
        <button
          className="panel col center reveal-card assignment-card reveal-locked-card"
          style={{ gap: 12, cursor: 'pointer', ...cardBackCss(savedCardBack()) }}
          onClick={() => setRevealed(true)}
        >
          <div className="mono-dim reveal-tap">{t.reveal.tap}</div>
        </button>
      ) : (
        <div className="panel reveal-card assignment-card role-reveal-card">
          <div className="eyebrow reveal-overline">{t.reveal.your}</div>

          <div className="role-reveal-art" style={{ backgroundImage: `url(${roleArt(myRole)})` }} />

          <div className="role-reveal-mark" style={{ color }}>
            <RoleIcon role={myRole} size={42} />
          </div>

          <div className="role-reveal-name">{t.role.name[myRole]}</div>

          <div className="mono-dim role-reveal-goal">
            {t.role.goal[myRole]}
          </div>

          {character && (
            <div className="panel col reveal-power">
              <div className="row between">
                <span className="eyebrow reveal-power-label">{t.reveal.power}</span>
                <span className="reveal-character-name">{character}</span>
              </div>
              {ability && (
                <span className="mono-dim reveal-power-copy">{ability}</span>
              )}
            </div>
          )}
        </div>
      )}

      <button
        className="btn block magenta reveal-enter"
        disabled={!revealed}
        onClick={session.enterTable}
      >
        {t.reveal.enter}
      </button>
    </div>
  );
}
